import { createCriteriaParameters, standardDeleteQuery, standardGetQuery, standardPostQuery, standardPutQuery } from "./apiUtils.js";

import { replacePlaceholdersWithObjValues, setDeleteArrayState, setInsertArrayState } from "../shared/miscUtils.js";
import { logUserOut } from "../auth/userAuthUtils.js";

import { SNACKBAR_ERROR_SESSION_EXPIRED, SNACKBAR_SUCCESS_CREATED, SNACKBAR_SUCCESS_DELETED, SNACKBAR_SUCCESS_UPDATED } from "../../config/language/english.js";
import * as Constants from "../../config/constants/Constants.js";

/**
 * Function for querying users with filters, pagination, sorting etc.
 */
export const queryUsers = (props, options = {}) => {
    const path = Constants.API_USERS + createCriteriaParameters(options);

    standardGetQuery(props, path, (response) => {
        const states = props.backend.users;

        setInsertArrayState(states.setData, response.body.elements);
        states.setQueryLoading(false);

        if (options.pagination === false) return;

        if (options.page !== undefined) states.setQueriedUntil(options.page);
        if (response?.body?.total !== undefined) states.setRowCount(response.body.total);
    });
};

/**
 * Function for querying an existing user.
 */
export const queryUser = (props, options = {}) => {
    const path = replacePlaceholdersWithObjValues(Constants.API_USERS_ID, { user_id: options.id });

    standardGetQuery(props, path, (response) => {
        const states = props.backend.users;

        setInsertArrayState(states.setData, [{ ...response.body }]);
    });
};

/**
 * Function for querying the current user.
 */
export const queryUserMe = (props) => {
    const path = Constants.API_USERS_ME;

    standardGetQuery(props, path, (response) => {
        props.user.setMe(response.body);
    });
};

/**
 * Function for updating the current user.
 */
export const updateUserMe = (props, options = {}, callback = null) => {
    const path = Constants.API_USERS_ME;

    standardPutQuery(props, path, options.body, (response) => {
        props.user.setMe(response.body);

        props.showSnackbar({ message: SNACKBAR_SUCCESS_UPDATED });
        if (callback) callback(response);
    });
};

/**
 * Function for deleting the current user.
 */
export const deleteUserMe = (props) => {
    const path = Constants.API_USERS_ME;

    standardDeleteQuery(props, path, undefined, (response) => {
        props.showSnackbar({ message: SNACKBAR_ERROR_SESSION_EXPIRED });
        logUserOut(props);
    });
};

/**
 * Function for creating a new user.
 */
export const createUser = (props, options = {}) => {
    const path = Constants.API_USERS;

    standardPostQuery(props, path, options.body, (response) => {
        const states = props.backend.users;

        setInsertArrayState(states.setData, [{ ...response.body }]);
        states.setRowCount((prev) => prev + 1);

        props.showSnackbar({ message: SNACKBAR_SUCCESS_CREATED });
    });
};

/**
 * Function for updating a user.
 */
export const updateUser = (props, options = {}, callback = null) => {
    const path = replacePlaceholdersWithObjValues(Constants.API_USERS_ID, { user_id: options.id });

    standardPutQuery(props, path, options.body, (response) => {
        const states = props.backend.users;

        setInsertArrayState(states.setData, [{ ...response.body }]);

        states.setSelected([]);

        props.showSnackbar({ message: SNACKBAR_SUCCESS_UPDATED });
        if (callback) callback(response);
    });
};

/**
 * Function for deleting user(s).
 */
export const deleteUsers = (props, options = {}) => {
    const path = Constants.API_USERS;

    standardDeleteQuery(props, path, options.body, (response) => {
        const states = props.backend.users;

        setDeleteArrayState(states.setData, options.ids);

        states.setRowCount(states.rowCount - options.ids.length);
        states.setSelected([]);

        props.showSnackbar({ message: SNACKBAR_SUCCESS_DELETED });
    });
};
